export const useFormatPhoneNumber = (phoneNumber: string) => {
    const phoneRegex = /^(1|)?(\d{3})(\d{3})(\d{4})$/;
    let match = phoneNumber?.match(phoneRegex);
    let formattedPhoneNumber = "";
    if (match) {
        formattedPhoneNumber = `${match[2]}-${match[3]}-${match[4]}`;
    }
    return formattedPhoneNumber;
};
